/**
 * Session storage key used to persist the Pet Parent's
 * "Keep me signed in" preference across their current browser session.
 *
 * When set to `true`, the customer remains softly logged in after
 * their authenticated session expires, allowing limited personalization
 * without exposing PII.
 */
export const REMEMBER_ME_SESSION_STORAGE_KEY = 'remember_me';
